//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { createGlobalStyle } from 'styled-components'
export default createGlobalStyle`
    * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
    }
    body {
        background-color: #fcfcfc;
        font-family: sans-serif;
        font-smoothing: antialiased;
        overflow-y: auto;
    }
    @media (min-width: 768px) {
      body.react-draggable-transparent-selection, body{ overflow-x: hidden !important; }
    }
    
`;
